import React from 'react';
import { motion } from 'framer-motion';
export function MaintenanceMeaning() {
  return <section className="bg-white px-4 py-20 pt-[30px] pb-[30px]" data-id="element-105" data-mp="3m24tx9bd5ysa">
      <div className="mx-auto max-w-6xl" data-id="element-106" data-mp="3lzqxox4y6gj5">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[minmax(0,1fr)_320px] lg:gap-16" data-id="element-107" data-mp="4lmvvpsfk4tl">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="mx-auto max-w-3xl" data-id="element-108" data-mp="3vspn2h89qb3t">
            <span className="mb-4 block text-sm font-bold uppercase tracking-widest text-brand-accent pt-[20px]" data-id="element-109" data-mp="3d0dj5q1yv1rk">
              WHAT MAINTENANCE ACTUALLY MEANS
            </span>
            <h2 className="mb-8 font-heading font-extrabold uppercase tracking-wide text-brand-dark md:text-4xl lg:text-5xl text-[46px]" data-id="element-110" data-mp="sbpnk4sfn8ro">
              AN OIL CHANGE DOESN'T KEEP EVERYTHING ELSE FROM WEARING&nbsp;OUT.
            </h2>
            <div className="space-y-5 text-lg leading-relaxed text-gray-700 md:text-xl" data-id="element-111" data-mp="26ja73v2s8jfj">
              <p className="font-[500]" data-id="element-112" data-mp="2an84a08jrk5y">
                Most people think of maintenance as oil changes and maybe tires.
                That covers maybe 20% of what your vehicle actually needs over
                time. There's a longer list of services that happen on a
                different schedule. And it matters if you plan to keep your car
                long-term.
              </p>
              <p data-id="element-113" data-mp="1runtpywpu1qy">
                Brake fluid absorbs moisture over time and loses effectiveness.
                Transmission fluid breaks down. Coolant becomes acidic. Spark
                plugs degrade slowly. Timing belts don't announce when they're
                overdue; they just fail. These components deteriorate quietly —
                and by the time something fails, what would have been a routine
                service has turned into a major repair that costs more, takes
                longer, and disrupts your plans.
              </p>
              <p data-id="element-114" data-mp="2gadhl37hagt2"></p>
              <p className="font-[300]" data-id="element-115" data-mp="2g8sqjnkdhfzy">
                A real maintenance program means knowing what your specific
                vehicle needs at each mileage interval, staying ahead of it, and
                working with a shop that's honest about it with you.
              </p>
            </div>
          </motion.div>

          <motion.img initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} src="https://cdn.magicpatterns.com/uploads/gZ9Y4D8XQDcACEnC2HJAh6/Used-0316_Profile_RW_006.jpg" alt="Lancer Service technician inspecting a vehicle in the shop" className="order-first h-64 w-full rounded-2xl object-cover object-[center_25%] shadow-2xl shadow-black/20 lg:order-last lg:h-[480px]" data-id="element-116" data-mp="1jlfl9gk2yats" />
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mx-auto mt-14 max-w-3xl text-center text-xl font-bold text-brand-dark md:text-2xl" data-id="element-117" data-mp="37hccilxbvjiw">
          Taking care of your car now costs a lot less than fixing it later.
        </motion.p>
      </div>
    </section>;
}